import {
  TEntityOverride,
} from 'src/types'

import PathMap from './PathMap'

const override: TEntityOverride = {
  titleField: 'name',
  global: {
    properties: {
      groups: {
        type: 'groups',
      },
      location: {
        hidden: true,
      },
    },
  },
  edit: {
    properties: {
      locationHistory: {
        displayedComponent: PathMap,
      },
    },
  },
  list: {
    properties: {
      location: {
        hidden: true,
      },
    },
  },
  create: {
    properties: {
      location: {
        hidden: true,
      },
    },
  },
}

export default override
